/**
 * Module dependencies.
 */

import { Flag, PhoneWrapper, Wrapper } from './phones.style';
import { JSX, useMemo } from 'react';
import { Language } from 'types/language';
import { PhoneLink } from 'components/atoms/phone-link/phone-link';
import { getAsset } from 'utils/resolve-admin';
import { reduce } from 'lodash';

/**
 * `Props` type.
 */

type Props = {
  languages: Language[];
  phoneEN: string;
  phoneFR: string;
  phonePT: string;
};

/**
 * Export `Phones` component.
 */

export function Phones(props: Props): JSX.Element {
  const { languages, phoneEN, phoneFR, phonePT } = props;
  const phones = useMemo(() => {
    const result: any = [];
    const list = [
      { lang: 'pt', phone: phonePT },
      { lang: 'fr', phone: phoneFR },
      { lang: 'en', phone: phoneEN },
    ];

    const langs = reduce(
      languages,
      (acc, lang) => {
        const code = lang.code.split('-')[0];

        return {
          ...acc,
          [code]: lang,
        };
      },
      {},
    );

    for (const item of list) {
      const { lang, phone } = item;

      if (phone) {
        result.push({
          src: getAsset(langs[lang].icon.filename_disk, { height: 15 }),
          value: phone,
        });
      }
    }

    return result;
  }, [languages, phoneEN, phoneFR, phonePT]);

  return (
    <Wrapper>
      {phones.map((item, index) => (
        <PhoneWrapper key={index}>
          <Flag src={item.src} />

          <PhoneLink phone={item.value} />
        </PhoneWrapper>
      ))}
    </Wrapper>
  );
}
